import moment from 'moment'

export const ccf = {
    id: '',
    srNumber: '',
    product: '',
    customer: '',
    destination: '',
    scheduleProduct: '',
    address: '',
    isApproval: false,
    isApprovedRS: false,
    approvedBy : '',
    approvedByName: '',
    remark : '',
    isDelete: false,
    startDate : moment().format('YYYY-MM-DD'),
    dueDate: moment().format('YYYY-MM-DD'),
}